export default __webpack_public_path__ + "./assets/inter-v3-latin-700.woff";